import { FC } from "react";
import cx from "classnames";
import {
  containsOneLowercaseLetter,
  containsOneUppercaseLetter,
} from "../../helpers/validation";
import Icon, { IconTypes } from "../../../Icon";

import styles from "./styles.module.scss";

interface IProps {
  value: string;
}

const TooltipContent: FC<IProps> = ({ value }) => {
  return (
    <div className={styles.TooltipContent}>
      <p
        className={cx({
          [styles.highlighted]: containsOneLowercaseLetter(value),
        })}
      >
        <Icon type={IconTypes.CONFIRMED} size={16} />
        <span>At least 1 lowercase letter</span>
      </p>
      <p
        className={cx({
          [styles.highlighted]: containsOneUppercaseLetter(value),
        })}
      >
        <Icon type={IconTypes.CONFIRMED} size={16} />
        <span>At least 1 uppercase letter</span>
      </p>
      <p className={cx({ [styles.highlighted]: value.length >= 8 })}>
        <Icon type={IconTypes.CONFIRMED} size={16} />
        <span>Minimum 8 character</span>
      </p>
      <p className={cx({ [styles.highlighted]: value.length >= 1 })}>
        <Icon type={IconTypes.CONFIRMED} size={16} />
        <span>At least 1 number</span>
      </p>
    </div>
  );
};

export default TooltipContent;
